<ng-container
    *ngrxLet="{
        weatherViewMode: weatherViewMode$,
        openedPanel: openedPanel$,
        routes: routes$,
        areAreaBuffersProcessing: areAreaBuffersProcessing$,
        shouldShowAreaBuffers: shouldShowAreaBuffers$,
        viewControls: viewControls$,
        viewControlsValue: viewControlsValue$,
        mapLayers: mapLayers$,
        mapLayersValue: mapLayersValue$,
        weatherMissionStatus: weatherMissionStatus$,
        selectedZoneId: selectedZoneId$,
        isGeoZonesInfoEnabled: isGeoZonesInfoEnabled$,
        geoZonesWithInfo: geoZonesWithInfo$,
        dronePointsDetails: dronePointsDetails$,
        isDronePointsDetailsProcessing: isDronePointsDetailsProcessing$,
        geoZonesControls: geoZonesControls$,
        missionTimeRange: missionTimeRange$,
        isKmlImportEnabled: isKmlImportEnabled$,
        kmlFiles: kmlFiles$,
        globalOpacity: globalOpacity$,
        selectedZoneTimesSetting: selectedZoneTimesSetting$,
        isZoneInfoError: isZoneInfoError$,
        isPoiSearchEnabled: isPoiSearchEnabled$,
        isRpaDescriptionProcessing: isRpaDescriptionProcessing$,
        rpaDescriptions: rpaDescriptions$,
        areTrackingReceiversVisible: areTrackingReceiversVisible$
    } as vm"
>
    <mat-progress-bar *ngIf="isGeoZonesDataProcessing$ | ngrxPush" mode="indeterminate" class="geo-zones-loader" />
    <div class="layers-controls" [class.control-opened]="vm.openedPanel">
        <div class="action-container">
            <button
                type="button"
                class="toggle-button spatial-data-button"
                [class.opened]="vm.openedPanel === ControlPanel.GeoZones"
                (click)="togglePanel(ControlPanel.GeoZones)"
            >
                <dtm-ui-icon
                    name="cylinder-line"
                    class="spatial-data-icon"
                    [class.active]="
                        vm.geoZonesControls.geoZonesSettings?.areGeoZonesEnabled ||
                        vm.geoZonesControls.localSpatialInfoForDtmSettings?.isLocalSpatialInfoForDtmEnabled
                    "
                />
                <ng-container
                    *ngIf="
                        !vm.geoZonesControls.geoZonesSettings?.areGeoZonesEnabled &&
                        !vm.geoZonesControls.localSpatialInfoForDtmSettings?.isLocalSpatialInfoForDtmEnabled
                    "
                >
                    {{ "dtmMapCesium.spatialDataTitle" | transloco }}
                </ng-container>
                <p
                    *ngIf="
                        vm.geoZonesControls.geoZonesSettings?.areGeoZonesEnabled ||
                        vm.geoZonesControls.localSpatialInfoForDtmSettings?.isLocalSpatialInfoForDtmEnabled
                    "
                >
                    {{ "dtmMapCesium.spatialDataTitle" | transloco : { value: vm.selectedZoneTimesSetting } }}
                    <span>
                        {{
                            "dtmMapCesium.spatialDataHeightInfoLabel"
                                | transloco : { value: vm.geoZonesControls.geoZonesFilters?.zoneHeight | localizeNumber }
                        }}{{
                            (vm.selectedZoneTimesSetting === ZoneTimesSetting.CustomTimeRange ||
                                vm.selectedZoneTimesSetting === ZoneTimesSetting.FromNow) &&
                            vm.geoZonesControls.geoZonesFilters &&
                            vm.geoZonesControls.geoZonesFilters.timeFrom &&
                            vm.geoZonesControls.geoZonesFilters.timeTo
                                ? "," +
                                  (vm.geoZonesControls.geoZonesFilters.timeFrom | datesDiff : vm.geoZonesControls.geoZonesFilters.timeTo)
                                : ""
                        }}
                    </span>
                </p>
                <dtm-ui-icon [name]="vm.openedPanel === ControlPanel.GeoZones ? 'arrow-up' : 'arrow-down'" class="arrow-icon" />
            </button>
            <div class="toggle-container" *ngIf="vm.shouldShowAreaBuffers">
                <button
                    type="button"
                    class="toggle-button"
                    [class.opened]="vm.openedPanel === ControlPanel.MissionViewSettings"
                    (click)="togglePanel(ControlPanel.MissionViewSettings)"
                >
                    <dtm-ui-icon name="route" />
                    {{ "dtmMapCesium.missionViewControls.title" | transloco }}
                    <dtm-ui-icon [name]="vm.openedPanel === ControlPanel.MissionViewSettings ? 'arrow-up' : 'arrow-down'" />
                </button>
                <div class="controls-container" [class.visible]="vm.openedPanel === ControlPanel.MissionViewSettings">
                    <dtm-map-mission-view-settings
                        [viewControls]="vm.viewControls"
                        [viewControlsValue]="vm.viewControlsValue"
                        (viewControlsValueChange)="updateViewControlsValue($event)"
                    />
                </div>
            </div>
            <button
                type="button"
                class="toggle-button"
                [class.opened]="vm.openedPanel === ControlPanel.MapLayers"
                (click)="togglePanel(ControlPanel.MapLayers)"
            >
                <dtm-ui-icon name="stack-line" />
                {{ "dtmMapCesium.mapLayersSelector.title" | transloco }}
                <dtm-ui-icon [name]="vm.openedPanel === ControlPanel.MapLayers ? 'arrow-up' : 'arrow-down'" />
            </button>
            <div class="toggle-container">
                <button
                    type="button"
                    class="toggle-button"
                    *ngIf="vm.weatherViewMode !== WeatherViewMode.Hide"
                    [class.opened]="vm.openedPanel === ControlPanel.Weather"
                    (click)="togglePanel(ControlPanel.Weather)"
                >
                    <div
                        *ngIf="weatherMissionStatus$ | ngrxPush as weatherStatus"
                        [ngClass]="['status', weatherStatus]"
                        [class.pulse]="weatherStatus === WeatherStatus.Danger || weatherStatus === WeatherStatus.Warning"
                    ></div>
                    <dtm-ui-icon name="rainy" />
                    {{ "dtmMapCesium.weatherLabel" | transloco }}
                    <dtm-ui-icon [name]="vm.openedPanel == ControlPanel.Weather ? 'arrow-up' : 'arrow-down'" />
                </button>
            </div>
            <div class="toggle-container" *ngIf="vm.isKmlImportEnabled && vm.kmlFiles.length">
                <button type="button" class="toggle-button" (click)="togglePanel(ControlPanel.KmlControls)">
                    <dtm-ui-icon
                        #kmlViewIcon
                        name="attachment"
                        class="kml-icon"
                        [class.disabled]="vm.kmlFiles | invoke : isKmlIconDisabled"
                    />
                    {{ "dtmMapCesium.kmlViewSettings.mapButtonLabel" | transloco }}
                    <dtm-ui-icon [name]="vm.openedPanel === ControlPanel.KmlControls ? 'arrow-up' : 'arrow-down'" />
                </button>
                <div class="controls-container" [class.visible]="vm.openedPanel === ControlPanel.KmlControls">
                    <dtm-map-kml-controls
                        [kmlDataSet]="vm.kmlFiles"
                        (allKmlDataDelete)="kmlControlService.deleteAllKmlData()"
                        (kmlImportModalOpen)="kmlControlService.openKmlImportModal()"
                        (visibilityChange)="kmlViewIcon.classList.toggle('disabled', !$event); kmlControlService.refreshView()"
                        (kmlDataZoom)="kmlControlService.zoomToKmlData($event)"
                    />
                </div>
            </div>
            <div class="toggle-container">
                <button
                    type="button"
                    class="toggle-button"
                    [class.opened]="vm.openedPanel === element.panelKey"
                    *ngFor="let element of customElements"
                    (click)="togglePanel(element.panelKey)"
                >
                    <dtm-ui-icon [name]="element.icon" *ngIf="element.icon" />
                    {{ element.name | transloco }}
                    <dtm-ui-icon [name]="vm.openedPanel === element.panelKey ? 'arrow-up' : 'arrow-down'" />
                </button>
            </div>
        </div>
        <div class="additional-features-container">
            <ng-container *ngIf="vm.isKmlImportEnabled">
                <button
                    type="button"
                    class="button-icon menu-button toggle-button"
                    [matMenuTriggerFor]="additionalFeatures"
                    [attr.aria-label]="'dtmMapCesium.additionalFeaturesButtonArialLabel' | transloco"
                >
                    <dtm-ui-icon name="more" />
                </button>
                <mat-menu #additionalFeatures="matMenu" xPosition="before">
                    <button mat-menu-item type="button" (click)="openKmlImportModal()">
                        <dtm-ui-icon name="upload" />
                        {{ "dtmMapCesium.kmlImport.importButtonLabel" | transloco }}
                    </button>
                </mat-menu>
            </ng-container>
            <div class="poi-search-container" *ngIf="isPoiSearchAvailable$ | ngrxPush">
                <button
                    type="button"
                    class="button-icon menu-button toggle-button"
                    (click)="togglePoiSearch()"
                    [attr.aria-label]="'dtmMapCesium.mapSearchButtonLabel' | transloco"
                >
                    <dtm-ui-icon name="search" *ngIf="!vm.isPoiSearchEnabled" @fade />
                    <dtm-ui-icon name="close" *ngIf="vm.isPoiSearchEnabled" @fade />
                </button>

                <div class="list-wrapper" *ngIf="vm.isPoiSearchEnabled" @slideInOut>
                    <dtm-map-search (closePanel)="togglePoiSearch()" />
                </div>
            </div>
        </div>
        <div class="controls-container" [class.visible]="vm.openedPanel === ControlPanel.GeoZones">
            <dtm-map-geographical-zones-controls
                @slideIn
                [missionTimeRange]="vm.missionTimeRange"
                [timeSettingsOptions]="timeSettingsOptions$ | ngrxPush"
                [aupEndTime]="aupEndTime$ | ngrxPush"
                (geoZonesFilterSettingsUpdate)="handeGeographicalZonesFilterSettingsUpdate($event)"
                (watchZonesSettingUpdate)="onWatchZonesSettingUpdate($event)"
                (opacitySettingUpdate)="setGlobalOpacity($event)"
                (selectedZoneTimeSettingUpdate)="setZoneTimesSetting($event)"
            />
        </div>
        <div class="controls-container" [class.visible]="vm.openedPanel === ControlPanel.Weather">
            <dtm-map-weather
                [weatherList]="weatherRangeList$ | ngrxPush"
                [weatherByMissionTime]="weatherByMissionTime$ | ngrxPush"
                [weatherViewMode]="vm.weatherViewMode"
                [selectedWeatherRangeIndex]="selectedWeatherRangeIndex$ | ngrxPush"
                [isProcessing]="isWeatherProcessing$ | ngrxPush"
                [isWithinDtm]="isWithinDtm$ | ngrxPush"
                [forecastRefTime]="forecastRefTime$ | ngrxPush"
                [supportedWeatherZones]="supportedWeatherZones$ | ngrxPush"
                (zoneSelected)="selectZone($event)"
            />
        </div>
        <div class="controls-container" [class.visible]="vm.openedPanel === ControlPanel.MapLayers">
            <dtm-map-layers-selector
                [mapLayers]="vm.mapLayers"
                [mapLayersValue]="vm.mapLayersValue"
                [isTrackingReceiversSwitchEnabled]="vm.areTrackingReceiversVisible"
                (mapLayersValueChange)="updateMapLayersValue($event)"
                (trackingReceiversValueChange)="updateTrackingReceiversVisibility($event)"
            />
        </div>
        <div class="controls-container" [class.visible]="vm.openedPanel === element.panelKey" *ngFor="let element of customElements">
            <div class="custom-element-wrapper">
                <ng-container *ngTemplateOutlet="element.template; context: { isOpened: vm.openedPanel === element.panelKey }" />
            </div>
        </div>
    </div>

    <dtm-map-layer-provider *ngIf="mapLayersOptions$ | ngrxPush as options" [provider]="WebMapServiceImageryProvider" [options]="options" />

    <dtm-map-geographical-zones-layer
        [zones]="geoZones$ | ngrxPush"
        [shouldShow]="!!vm.geoZonesControls.geoZonesSettings?.areGeoZonesEnabled"
        [selectedZoneId]="vm.selectedZoneId"
        [globalZoneOpacity]="vm.globalOpacity"
    />

    <dtm-map-geographical-zones-layer
        [zones]="customZonesLayersData$ | ngrxPush"
        [customZoneStyles]="customZoneStyles$ | ngrxPush"
        shouldShow
        [selectedZoneId]="vm.selectedZoneId"
        [globalZoneOpacity]="vm.globalOpacity"
    />

    <dtm-map-geographical-zones-layer
        [zones]="localSpatialInfoData$ | ngrxPush"
        [simpleZones]="localSpatialAdditionalInfo$ | ngrxPush"
        [shouldShow]="!!vm.geoZonesControls.localSpatialInfoForDtmSettings?.isLocalSpatialInfoForDtmEnabled"
        [selectedZoneId]="vm.selectedZoneId"
        [globalZoneOpacity]="vm.globalOpacity"
    />

    <ng-container *ngIf="vm.shouldShowAreaBuffers">
        <dtm-map-lib-buffer-areas-layer
            *ngFor="let route of vm.routes; trackBy: trackByIndex"
            [isProcessing]="vm.areAreaBuffersProcessing"
            [route]="route"
            [isSafetyAreaVisible]="!!vm.viewControlsValue.SafetyArea"
            [isGroundRiskAreaVisible]="!!vm.viewControlsValue.GroundRiskBuffer"
        />
    </ng-container>

    <dtm-map-geographical-zones-info
        [selectedZoneId]="vm.selectedZoneId"
        [isEnabled]="vm.isGeoZonesInfoEnabled"
        [zonesWithInfo]="vm.geoZonesWithInfo"
        [dronePointsDetails]="vm.dronePointsDetails"
        [isDronePointsDetailsProcessing]="vm.isDronePointsDetailsProcessing"
        [isError]="vm.isZoneInfoError"
        [isRpaDescriptionProcessing]="vm.isRpaDescriptionProcessing"
        [rpaDescriptions]="vm.rpaDescriptions"
        (zoneSelectionChange)="selectZoneById($event)"
        (getZonesInfo)="getZonesWithInfo($event)"
        (rpaDescriptionsAreaChange)="rpaDescriptionsAreaChange.emit($event)"
    />
    <dtm-map-search-layer />
</ng-container>
